// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Formality from "../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as OrderStage from "../../../../ticket-dashboard/app/tickets/entities/OrderStage.bs.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Belt_Result from "../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Row$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as GeoRegionHook from "../../../../../../library/data-source/geo-region/repo/GeoRegionHook.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as TicketRaisedBy from "../../../../ticket-dashboard/app/tickets/entities/TicketRaisedBy.bs.js";
import * as Button$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";
import * as MsisdnValidation from "../../../../../../library/work-space/form/MsisdnValidation.bs.js";
import * as FormInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as MobileNumberValidation from "../../../../../../library/work-space/form/MobileNumberValidation.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as RaiseTicketStateMachine from "../RaiseTicketStateMachine.bs.js";
import * as PrimitiveFormTypes$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/PrimitiveFormTypes.bs.js";
import * as FormRadioGroupInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormRadioGroupInput.bs.js";
import * as FormValidationUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/FormValidationUtils.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

var validators_location = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* String */1,
                      _0: param.location
                    }), (function ($$location) {
                    return {
                            TAG: /* Ok */0,
                            _0: $$location
                          };
                  }));
    })
};

var validators_orderStage = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* String */1,
                      _0: param.orderStage
                    }), (function (orderStage) {
                    return {
                            TAG: /* Ok */0,
                            _0: OrderStage.fromString(orderStage)
                          };
                  }));
    })
};

var validators_raisedBy = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* String */1,
                      _0: param.raisedBy
                    }), (function (raisedBy) {
                    return {
                            TAG: /* Ok */0,
                            _0: TicketRaisedBy.fromString(raisedBy)
                          };
                  }));
    })
};

var validators_msisdn = {
  strategy: /* OnSubmit */4,
  validate: (function (param, metadata) {
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* String */1,
                      _0: param.msisdn
                    }), (function (msisdn) {
                    return MsisdnValidation.execute(msisdn, metadata.country);
                  }));
    })
};

var validators_callerNumber = {
  strategy: /* OnSubmit */4,
  validate: (function (param, metadata) {
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* String */1,
                      _0: param.callerNumber
                    }), (function (callerNumber) {
                    return MobileNumberValidation.execute(callerNumber, metadata.country);
                  }));
    })
};

var validators_crn = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* String */1,
                      _0: param.crn
                    }), FormValidationUtils$Catalyst.validateCRN);
    })
};

var validators = {
  location: validators_location,
  orderStage: validators_orderStage,
  raisedBy: validators_raisedBy,
  msisdn: validators_msisdn,
  callerNumber: validators_callerNumber,
  crn: validators_crn
};

function initialFieldsStatuses(_input) {
  return {
          location: /* Pristine */0,
          orderStage: /* Pristine */0,
          raisedBy: /* Pristine */0,
          msisdn: /* Pristine */0,
          callerNumber: /* Pristine */0,
          crn: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: initialFieldsStatuses(input),
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  var match = fieldsStatuses.location;
  var match_0 = match ? match._0 : Curry._2(validators.location.validate, input, metadata);
  var match$1 = fieldsStatuses.orderStage;
  var match_0$1 = match$1 ? match$1._0 : Curry._2(validators.orderStage.validate, input, metadata);
  var match$2 = fieldsStatuses.raisedBy;
  var match_0$2 = match$2 ? match$2._0 : Curry._2(validators.raisedBy.validate, input, metadata);
  var match$3 = fieldsStatuses.msisdn;
  var match_0$3 = match$3 ? match$3._0 : Curry._2(validators.msisdn.validate, input, metadata);
  var match$4 = fieldsStatuses.callerNumber;
  var match_0$4 = match$4 ? match$4._0 : Curry._2(validators.callerNumber.validate, input, metadata);
  var match$5 = fieldsStatuses.crn;
  var match_0$5 = match$5 ? match$5._0 : Curry._2(validators.crn.validate, input, metadata);
  var locationResult = match_0;
  var locationResult$1;
  if (locationResult.TAG === /* Ok */0) {
    var orderStageResult = match_0$1;
    if (orderStageResult.TAG === /* Ok */0) {
      var raisedByResult = match_0$2;
      if (raisedByResult.TAG === /* Ok */0) {
        var msisdnResult = match_0$3;
        if (msisdnResult.TAG === /* Ok */0) {
          var callerNumberResult = match_0$4;
          if (callerNumberResult.TAG === /* Ok */0) {
            var crnResult = match_0$5;
            if (crnResult.TAG === /* Ok */0) {
              return {
                      TAG: /* Valid */0,
                      output: {
                        crn: crnResult._0,
                        callerNumber: callerNumberResult._0,
                        msisdn: msisdnResult._0,
                        raisedBy: raisedByResult._0,
                        orderStage: orderStageResult._0,
                        location: locationResult._0
                      },
                      fieldsStatuses: {
                        location: /* Dirty */{
                          _0: locationResult,
                          _1: /* Shown */0
                        },
                        orderStage: /* Dirty */{
                          _0: orderStageResult,
                          _1: /* Shown */0
                        },
                        raisedBy: /* Dirty */{
                          _0: raisedByResult,
                          _1: /* Shown */0
                        },
                        msisdn: /* Dirty */{
                          _0: msisdnResult,
                          _1: /* Shown */0
                        },
                        callerNumber: /* Dirty */{
                          _0: callerNumberResult,
                          _1: /* Shown */0
                        },
                        crn: /* Dirty */{
                          _0: crnResult,
                          _1: /* Shown */0
                        }
                      },
                      collectionsStatuses: undefined
                    };
            }
            locationResult$1 = locationResult;
          } else {
            locationResult$1 = locationResult;
          }
        } else {
          locationResult$1 = locationResult;
        }
      } else {
        locationResult$1 = locationResult;
      }
    } else {
      locationResult$1 = locationResult;
    }
  } else {
    locationResult$1 = locationResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            location: /* Dirty */{
              _0: locationResult$1,
              _1: /* Shown */0
            },
            orderStage: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            raisedBy: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            },
            msisdn: /* Dirty */{
              _0: match_0$3,
              _1: /* Shown */0
            },
            callerNumber: /* Dirty */{
              _0: match_0$4,
              _1: /* Shown */0
            },
            crn: /* Dirty */{
              _0: match_0$5,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, metadata, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurLocationField */0 :
                  var result = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.location, validators_location, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  location: status,
                                  orderStage: init.orderStage,
                                  raisedBy: init.raisedBy,
                                  msisdn: init.msisdn,
                                  callerNumber: init.callerNumber,
                                  crn: init.crn
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurOrderStageField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.orderStage, validators_orderStage, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  location: init.location,
                                  orderStage: status,
                                  raisedBy: init.raisedBy,
                                  msisdn: init.msisdn,
                                  callerNumber: init.callerNumber,
                                  crn: init.crn
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurRaisedByField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.raisedBy, validators_raisedBy, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  location: init.location,
                                  orderStage: init.orderStage,
                                  raisedBy: status,
                                  msisdn: init.msisdn,
                                  callerNumber: init.callerNumber,
                                  crn: init.crn
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurMsisdnField */3 :
                  var result$3 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.msisdn, validators_msisdn, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  location: init.location,
                                  orderStage: init.orderStage,
                                  raisedBy: init.raisedBy,
                                  msisdn: status,
                                  callerNumber: init.callerNumber,
                                  crn: init.crn
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurCallerNumberField */4 :
                  var result$4 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.callerNumber, validators_callerNumber, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  location: init.location,
                                  orderStage: init.orderStage,
                                  raisedBy: init.raisedBy,
                                  msisdn: init.msisdn,
                                  callerNumber: status,
                                  crn: init.crn
                                };
                        }));
                  if (result$4 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$4,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurCrnField */5 :
                  var result$5 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.crn, validators_crn, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  location: init.location,
                                  orderStage: init.orderStage,
                                  raisedBy: init.raisedBy,
                                  msisdn: init.msisdn,
                                  callerNumber: init.callerNumber,
                                  crn: status
                                };
                        }));
                  if (result$5 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$5,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */6 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses, metadata);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */6,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */7,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */9);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */8);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */7 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */8 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */9 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateLocationField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput, metadata, state.fieldsStatuses.location, state.submissionStatus, validators_location, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            location: status,
                                            orderStage: init.orderStage,
                                            raisedBy: init.raisedBy,
                                            msisdn: init.msisdn,
                                            callerNumber: init.callerNumber,
                                            crn: init.crn
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateOrderStageField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$1, metadata, state.fieldsStatuses.orderStage, state.submissionStatus, validators_orderStage, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            location: init.location,
                                            orderStage: status,
                                            raisedBy: init.raisedBy,
                                            msisdn: init.msisdn,
                                            callerNumber: init.callerNumber,
                                            crn: init.crn
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateRaisedByField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$2, metadata, state.fieldsStatuses.raisedBy, state.submissionStatus, validators_raisedBy, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            location: init.location,
                                            orderStage: init.orderStage,
                                            raisedBy: status,
                                            msisdn: init.msisdn,
                                            callerNumber: init.callerNumber,
                                            crn: init.crn
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateMsisdnField */3 :
                  var nextInput$3 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$3, metadata, state.fieldsStatuses.msisdn, state.submissionStatus, validators_msisdn, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            location: init.location,
                                            orderStage: init.orderStage,
                                            raisedBy: init.raisedBy,
                                            msisdn: status,
                                            callerNumber: init.callerNumber,
                                            crn: init.crn
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateCallerNumberField */4 :
                  var nextInput$4 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$4,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$4, metadata, state.fieldsStatuses.callerNumber, state.submissionStatus, validators_callerNumber, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            location: init.location,
                                            orderStage: init.orderStage,
                                            raisedBy: init.raisedBy,
                                            msisdn: init.msisdn,
                                            callerNumber: status,
                                            crn: init.crn
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateCrnField */5 :
                  var nextInput$5 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$5,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$5, metadata, state.fieldsStatuses.crn, state.submissionStatus, validators_crn, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            location: init.location,
                                            orderStage: init.orderStage,
                                            raisedBy: init.raisedBy,
                                            msisdn: init.msisdn,
                                            callerNumber: init.callerNumber,
                                            crn: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */6 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: initialFieldsStatuses(input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: initialFieldsStatuses(state.input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */7 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */8 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateLocation: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateLocationField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateOrderStage: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateOrderStageField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateRaisedBy: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateRaisedByField */2,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateMsisdn: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateMsisdnField */3,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateCallerNumber: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateCallerNumberField */4,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateCrn: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateCrnField */5,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurLocation: (function (param) {
              return Curry._1(dispatch, /* BlurLocationField */0);
            }),
          blurOrderStage: (function (param) {
              return Curry._1(dispatch, /* BlurOrderStageField */1);
            }),
          blurRaisedBy: (function (param) {
              return Curry._1(dispatch, /* BlurRaisedByField */2);
            }),
          blurMsisdn: (function (param) {
              return Curry._1(dispatch, /* BlurMsisdnField */3);
            }),
          blurCallerNumber: (function (param) {
              return Curry._1(dispatch, /* BlurCallerNumberField */4);
            }),
          blurCrn: (function (param) {
              return Curry._1(dispatch, /* BlurCrnField */5);
            }),
          locationResult: Formality.exposeFieldResult(state.fieldsStatuses.location),
          orderStageResult: Formality.exposeFieldResult(state.fieldsStatuses.orderStage),
          raisedByResult: Formality.exposeFieldResult(state.fieldsStatuses.raisedBy),
          msisdnResult: Formality.exposeFieldResult(state.fieldsStatuses.msisdn),
          callerNumberResult: Formality.exposeFieldResult(state.fieldsStatuses.callerNumber),
          crnResult: Formality.exposeFieldResult(state.fieldsStatuses.crn),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.location || match.orderStage || match.raisedBy || match.msisdn || match.callerNumber || match.crn) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses, metadata);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */6);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */7);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */8);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */8,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */9);
            })
        };
}

var TicketForm = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function BasicInfoForm(Props) {
  var form_data = Props.form_data;
  var dispatch = Props.dispatch;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var form = useForm({
        crn: Belt_Option.getWithDefault(form_data.crn, ""),
        callerNumber: Belt_Option.getWithDefault(form_data.caller_number, ""),
        msisdn: Belt_Option.getWithDefault(form_data.msisdn, ""),
        raisedBy: Belt_Option.mapWithDefault(form_data.raised_by, "", TicketRaisedBy.toString),
        orderStage: Belt_Option.mapWithDefault(form_data.order_stage, "", OrderStage.toString),
        location: Belt_Option.getWithDefault(form_data.location, "")
      }, {
        country: country
      }, (function (output, _form) {
          var formData_msisdn = output.msisdn;
          var formData_crn = output.crn;
          var formData_location = output.location;
          var formData_caller_number = output.callerNumber;
          var formData_order_stage = output.orderStage;
          var formData_raised_by = output.raisedBy;
          var formData = {
            msisdn: formData_msisdn,
            crn: formData_crn,
            location: formData_location,
            caller_number: formData_caller_number,
            order_stage: formData_order_stage,
            raised_by: formData_raised_by,
            crt_id: undefined
          };
          Curry._1(dispatch, {
                TAG: /* UpdateBasicInfoFormData */4,
                selected_basic_info: formData
              });
          if (Caml_obj.caml_notequal(form_data.order_stage, output.orderStage)) {
            Curry._1(dispatch, {
                  TAG: /* SetAvailableIssues */1,
                  issues: /* Init */0
                });
            Curry._1(dispatch, {
                  TAG: /* SetAvailableActions */2,
                  actions: /* Init */0
                });
            Curry._1(dispatch, {
                  TAG: /* UpdateIssueFormData */5,
                  issue_form_data: RaiseTicketStateMachine.getInitialIssueFormData(undefined)
                });
            Curry._1(dispatch, {
                  TAG: /* UpdateActionFormData */6,
                  action_form_data: RaiseTicketStateMachine.getInitialActionFormData(undefined)
                });
          }
          return Curry._1(dispatch, {
                      TAG: /* UpdateView */3,
                      current_view: /* IssueForm */1
                    });
        }));
  var georegions = GeoRegionHook.useGeoRegions(country);
  switch (georegions.TAG | 0) {
    case /* Loading */0 :
        return React.createElement(CircularLoader$Catalyst.make, {});
    case /* Live */1 :
        return React.createElement("div", {
                    className: "c-raise-ticket-form-info-container"
                  }, React.createElement("form", {
                        className: "raise-ticket-form-info",
                        onSubmit: (function ($$event) {
                            $$event.preventDefault();
                            return Curry._1(form.submit, undefined);
                          })
                      }, React.createElement("div", {
                            className: "raise-ticket-form-info-section"
                          }, React.createElement(Row$Catalyst.make, {
                                children: React.createElement(FormTextInput$Catalyst.make, {
                                      input_props: FormInput$Catalyst.make_props("Crn", (function ($$event) {
                                              return Curry._2(form.updateCrn, (function (input, value) {
                                                            return {
                                                                    crn: value,
                                                                    callerNumber: input.callerNumber,
                                                                    msisdn: input.msisdn,
                                                                    raisedBy: input.raisedBy,
                                                                    orderStage: input.orderStage,
                                                                    location: input.location
                                                                  };
                                                          }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                            }), undefined, undefined, undefined, undefined, undefined, undefined, form.crnResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                      textinput_props: {
                                        value: form.input.crn
                                      }
                                    })
                              }), React.createElement(FormTextInput$Catalyst.make, {
                                input_props: FormInput$Catalyst.make_props("Caller Number", (function ($$event) {
                                        return Curry._2(form.updateCallerNumber, (function (input, value) {
                                                      return {
                                                              crn: input.crn,
                                                              callerNumber: value,
                                                              msisdn: input.msisdn,
                                                              raisedBy: input.raisedBy,
                                                              orderStage: input.orderStage,
                                                              location: input.location
                                                            };
                                                    }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                      }), undefined, undefined, undefined, undefined, undefined, undefined, form.callerNumberResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                textinput_props: {
                                  value: form.input.callerNumber
                                }
                              }), React.createElement(FormTextInput$Catalyst.make, {
                                input_props: FormInput$Catalyst.make_props("MSISDN", (function ($$event) {
                                        return Curry._2(form.updateMsisdn, (function (input, value) {
                                                      return {
                                                              crn: input.crn,
                                                              callerNumber: input.callerNumber,
                                                              msisdn: value,
                                                              raisedBy: input.raisedBy,
                                                              orderStage: input.orderStage,
                                                              location: input.location
                                                            };
                                                    }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                      }), undefined, undefined, undefined, undefined, undefined, undefined, form.msisdnResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                textinput_props: {
                                  value: form.input.msisdn
                                }
                              }), React.createElement("div", undefined, React.createElement("label", {
                                    className: "raise-ticket-row-title"
                                  }, "Location"), React.createElement(FormRadioGroupInput$Catalyst.make, {
                                    input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                            return Curry._2(form.updateLocation, (function (input, value) {
                                                          return {
                                                                  crn: input.crn,
                                                                  callerNumber: input.callerNumber,
                                                                  msisdn: input.msisdn,
                                                                  raisedBy: input.raisedBy,
                                                                  orderStage: input.orderStage,
                                                                  location: value
                                                                };
                                                        }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                          }), undefined, undefined, undefined, undefined, undefined, undefined, form.locationResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                    radio_props: {
                                      options: List.map((function (param) {
                                              var name = param.name;
                                              return {
                                                      label: name,
                                                      value: name
                                                    };
                                            }), georegions._0),
                                      value: form.input.location,
                                      row_layout: false
                                    }
                                  })), React.createElement("div", undefined, React.createElement("label", {
                                    className: "raise-ticket-row-title"
                                  }, "Raised By"), React.createElement(FormRadioGroupInput$Catalyst.make, {
                                    input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                            return Curry._2(form.updateRaisedBy, (function (input, value) {
                                                          return {
                                                                  crn: input.crn,
                                                                  callerNumber: input.callerNumber,
                                                                  msisdn: input.msisdn,
                                                                  raisedBy: value,
                                                                  orderStage: input.orderStage,
                                                                  location: input.location
                                                                };
                                                        }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                          }), undefined, undefined, undefined, undefined, undefined, undefined, form.raisedByResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                    radio_props: {
                                      options: List.map((function (raisedBy) {
                                              return {
                                                      label: TicketRaisedBy.toString(raisedBy),
                                                      value: TicketRaisedBy.toString(raisedBy)
                                                    };
                                            }), TicketRaisedBy.getListOfRaisedBy(undefined)),
                                      value: form.input.raisedBy,
                                      row_layout: false
                                    }
                                  })), React.createElement("div", undefined, React.createElement("label", {
                                    className: "raise-ticket-row-title"
                                  }, "Order Stage"), React.createElement(FormRadioGroupInput$Catalyst.make, {
                                    input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                            return Curry._2(form.updateOrderStage, (function (input, value) {
                                                          return {
                                                                  crn: input.crn,
                                                                  callerNumber: input.callerNumber,
                                                                  msisdn: input.msisdn,
                                                                  raisedBy: input.raisedBy,
                                                                  orderStage: value,
                                                                  location: input.location
                                                                };
                                                        }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                          }), undefined, undefined, undefined, undefined, undefined, undefined, form.orderStageResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                    radio_props: {
                                      options: List.map((function (orderStage) {
                                              return {
                                                      label: OrderStage.toString(orderStage),
                                                      value: OrderStage.toString(orderStage)
                                                    };
                                            }), OrderStage.getListOfOrderStage(undefined)),
                                      value: form.input.orderStage,
                                      row_layout: false
                                    }
                                  }))), React.createElement("div", {
                            className: "raise-ticket-form-info-btn-wrapper"
                          }, React.createElement(Button$Catalyst.make, {
                                text: "Next",
                                cb: (function (param) {
                                    
                                  }),
                                className: "raise-ticket-btn raise-ticket-form-next"
                              }))));
    case /* Error */2 :
        return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                    error: georegions._0
                  });
    
  }
}

var make = BasicInfoForm;

export {
  TicketForm ,
  make ,
  
}
/* react Not a pure module */
